document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;

  var targetId = toggle.getAttribute('aria-controls');
  var target = document.getElementById(targetId);
  if (!target) return;

  var expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  target.toggleAttribute('data-open', !expanded);
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('[data-menu-toggle][aria-expanded="true"]').forEach(function (toggle) {
    var target = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', 'false');
    if (target) target.removeAttribute('data-open');
    toggle.focus();
  });
});
